import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './ApplicationForm.css';
import { InputField, LoadingState } from './Common';
import Positions from './Positions';
import FakeData from '../fake-data';
import { Register, Login } from '../App';
import { window } from 'd3-selection';

class ApplicationForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            app: this.props.isPreview ? this.props.application : {
                profile: this.props.profile,
                sport: this.props.type === "T" ? FakeData.nullify(this.props.team.sport['name']).toLowerCase() : "",
                position: "",
                type: "You",
                comment: "",
                squad: 0,
                activeSquad: { id: null, name: "" },
                team: { name: "", id: null },
                isTeam: this.props.type === "T" ? true : false
            },
            isSelectingChild: false,
            isCoach: false,
            currentChild: { id: null, name: "" },
            isLoading: false,
            isDeclining: false,
            isAddingChild: this.props.isPreview ? true : false,
            errors: {
                sport: false,
                position: false,
                comment: false,
                team: false
            }
        }
    }

    componentWillMount() {
        this._isMounted = true;
        if (this.props.isPreview) {
            this.setState({ isLoading: true });
            this.getProfile(this.props.application.userTo)
        }
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    onApplicationTypeChanged = (type = "You") => {
        const { app } = this.state;
        const { profile } = this.props;
        if (type == "You") {
            app.profile = profile;
            app.type = type;
            this.setState({ app, isSelectingChild: false });
        } else {
            app.profile = { id: null };
            app.type = type;
            this.setState({ app, isSelectingChild: true });
        }
    }

    read = () => {
        const { application } = this.props;
        if (application.isRead) {
            return;
        }

        const _that = this;
        if (!this._isMounted) {
            return
        }

        FakeData.post("/readApplication.php?auth0", {
            id: application.id
        }, {
                success: ((res) => {

                }),

            })
    }

    getProfile = (child = { user: "" }, key = "user") => {
        const _that = this;
        const { app } = this.state;
        if (!this._isMounted) {
            return
        }

        console.log("sss");

        _that.setState({ isLoading: true });
        FakeData.post("/getUserProfile.php?auth0&id=" + child[key] + "&them=" + child[key], {}, {
            success: ((res) => {
                console.log("reached");
                if (!_that._isMounted) {
                    return
                }
                if (res.error && _that._isMounted) {
                    _that.setState({
                        errorChild: true,
                        isLoading: false,
                        isAddingChild: false
                    });
                } else if (_that._isMounted) {
                    app.profile = res;
                    _that.setState({
                        app,
                        errorChild: false,
                        isLoading: false,
                        isSelectingChild: false,
                        isAddingChild: false
                    });
                }
            }),
            error: ((err) => {
                console.log("reache_d");
                _that.setState({ errorChild: true, isLoading: false, isAddingChild: false });
            })
        })
    }

    onRegister = (child) => {
        this.getProfile(child, "username");
    }

    save = () => {
        const _that = this;
        const { profile, isPreview, withGuest, location } = this.props;
        const { app, isSelectingChild, isLoading, currentChild, isAddingChild, errors, isCoach } = this.state;
        if (!app.isTeam && !app.team.name === "") {
            errors.team = true;
            this.setState({ errors });
            return;
        }

        if (app.sport === "") {
            errors.sport = true;
            this.setState({ errors });
            return;
        }

        if (app.squad === 0) {
            errors.squad = true;
            FakeData.alert("Please select team squad!")
            this.setState({ errors });
            return;
        }

        if (app.position === "") {
            errors.position = true;
            FakeData.alert("Please select position!")
            this.setState({ errors });
            return;
        }

        let _users = [];

        if (isCoach) {
            const __list = [];
            const ___list = [];
            FakeData.listify(this.props.team.roles).filter((item, i) => {
                return !FakeData.inArray(item.role, ["Player", "Refree", "Score Keeper", "Coach", "Captain", "Student", "Team player"])
            }).forEach((item, i) => {
                __list.push(item.user);
            });

            FakeData.listify(this.props.team.roles).filter((item, i) => {
                return !FakeData.inArray(item.role, ["Player", "Captain"])
            }).forEach((item, i) => {
                ___list.push(item.user);
            });

            _users = app.isTeam ? ___list : __list
        } else {
            const _list = [];
            FakeData.listify(this.props.team.roles).filter((item, i) => {
                return !FakeData.inArray(item.role, ["Player", "Refree", "Score Keeper", "Captain", "Student", "Team player"])
            }).forEach((item, i) => {
                _list.push(item.user);
            });
            _users = !app.isTeam ? [app.team.activeSquad.coach, app.team.activeSquad.assCoach] : _list;
        }

        if (_users.length === 0) {
            FakeData.alert("Sorry you can't apply on this page due to a small number of admin roles needed for your current position")
            return;
        }

        const data = {
            player: app.profile,
            user: FakeData.getData("yoo"),
            position: app.position,
            comment: app.comment,
            sport: app.sport,
            users: this.props.team.roles,
            teamId: !app.isTeam ? app.team.id : this.props.team.id,
            squad: app.squad,
            isTeam: app.isTeam,
            teamType: "T"
        }

        FakeData.post("/applyForTeam.php?auth0", data, {
            success(res) {
                const _app = _that.props.isPreview ? _that.props.application : {
                    profile: _that.props.profile,
                    sport: _that.props.type === "T" ? FakeData.nullify(_that.props.team.sport['name']).toLowerCase() : "",
                    position: "",
                    type: "You",
                    comment: "",
                    squad: 0,
                    activeSquad: { id: null, name: "" },
                    team: { name: "", id: null },
                    isTeam: _that.props.type === "T" ? true : false
                }

                FakeData.alert("Application sent!");

                _that.setState({ app: _app });
            },
            error(e) {

            }
        }, true, "", () => { })
    }

    accept = () => {
        const _that = this;
        const { profile, isPreview, withGuest, location } = this.props;
        const { app, isSelectingChild, isLoading, currentChild, isAddingChild, errors } = this.state;
        if (!app.squad) {
            errors.squad = true;
            this.setState({ errors });
            return;
        }

        if (!app.jersey || app.jersey === 0) {
            errors.jersey = true;
            this.setState({ errors });
            return;
        }

        const player = {
            name: app.userTo.name,
            email: app.userTo.email,
            position: app.position,
            origin: app.profile.country,
            number: app.jersey,
            image: "",
            gender: app.profile.user_gender,
            height: app.profile.user_height,
            age: app.profile.age,
            games: 0,
            goals: 0
        }

        const dataTo = {
            teamId: this.props.team.id,
            squadId: app.squad,
            player,
            gender: player.gender,
            applicationId: app.id,
            user: app.user,
            userTo: app.userTo
        }

        FakeData.post("/registerSquadPlayer.php?auth0&form", dataTo, {
            success(res) {
                if (res.error) {
                    FakeData.alert("Could not add player to the team, check player email address and try again!");
                    _that.props.onAccept()
                } else {
                    _that.props.onAccept()
                }
            },
            error(err) {

            }
        }, true, "", (s) => { })
    }

    decline = () => {
        const _that = this;
        const { profile, isPreview, withGuest, location } = this.props;
        const { app, isSelectingChild, isLoading, currentChild, isAddingChild, errors } = this.state;

        if (!app.declineComment || app.declineComment === "") {
            errors.declineComment = true;
            this.setState({ errors });
            return;
        }

        const dataTo = {
            userTo: app.user,
            user: FakeData.getData("yoo"),
            comment: app.declineComment,
            team: app.team,
            squad: app.activeSquad,
            applicationId: app.id
        }

        FakeData.post("/declineApplication.php?auth0&form", dataTo, {
            success(res) {
                if (res.error) {
                    FakeData.alert("Server error, please try again later!");
                    _that.props.onAccept()
                } else {
                    _that.props.onAccept()
                }
            },
            error(err) {

            }
        }, true, "", (s) => { })
    }

    render() {
        const { profile, isPreview, withGuest, location } = this.props;
        const { app, isSelectingChild, isLoading, currentChild, isAddingChild, errors, isDeclining, isCoach } = this.state;
        if (withGuest) {
            return (
                <div className={"team-application-form"}>
                    <span style={{ textAlign: "center", display: "block" }}>Please login to see the form : </span> <br />
                    <button className={"button"}><a href={"/login?ref=" + location.pathname} style={{ textAlign: "center", display: "block", width: "100%", height: "100%", color: "#fff" }}>Login</a></button>
                    <br />
                    <span style={{ textAlign: "center", display: "block" }}>or</span>
                    <br />
                    <button className={"button"}><a href={"/register"} style={{ textAlign: "center", display: "block", width: "100%", height: "100%", color: "#fff" }}>Register</a></button>
                </div>
            )
        }

        if (isLoading || !app.profile) {
            return (
                <div className={"team-application-form"}>
                    <LoadingState isShown={true} text={"Loading profile"} />
                </div>
            )
        }

        if (isSelectingChild) {
            return (
                <div className={"team-application-form"}>
                    <h3>Select the child you want to sign up</h3>
                    <InputField label={"Select Child"}>
                        <select style={{ padding: "4px" }} value={currentChild.name} onChange={(e) => {
                            if (e.target.value === "You") {
                                this.onApplicationTypeChanged("You");
                                return;
                            }
                            const _list = FakeData.listify(profile.children).filter((item, i) => {
                                return item.user.name === e.target.value;
                            });

                            if (_list.length > 0) {
                                this.setState({ currentChild: _list[0].user });
                                this.getProfile(_list[0].
                                    user);
                            } else if (_list.length === 0 && e.target.value === "") {
                                this.setState({ errorChild: true });
                            }
                        }} ref={(node) => {
                            if (node) {
                                node.style.setProperty("border", "1px solid #ccc", "important");
                                node.style.setProperty("height", "30px", "important");
                            }
                        }}>
                            <option value={""}>Select child</option>
                            <option value={"You"}>You</option>
                            {
                                profile.children.map((item, i) => {
                                    return (
                                        <option key={i} value={item.user.name}>{item.user.name}</option>
                                    )
                                })
                            }
                        </select>
                    </InputField>
                </div>
            )
        }

        return (
            <div className={"team-application-form"} style={{ minHeight: isPreview ? "500px" : "800px" }}>
                <h3>{isPreview ? "Application form for " + app.userTo.name + " (" + app.applicationType + ")" : "Team Registration Form"}</h3>
                {!isPreview && <p>Please complete the player form below</p>}
                {(FakeData.listify(profile.children).length === 0 || profile.isUngerAge && !isPreview) &&
                    <div className={"application-warn"}>
                        NB : You can't apply for a child, reason being you are still under the age of 13 or don't have children linked to your account.
                    </div>
                }

                {!isPreview && <button style={{ lineHeight: "30px", marginBottom: "10px", color: "#fff", background: "#4ac", padding: "0px 20px" }} onClick={() => {
                    this.setState({ isAddingChild: true });
                }}>Add Child</button>}

                <br />
                {FakeData.listify(profile.children).length > 0 && !profile.isUngerAge && !isPreview &&
                    <InputField label={"Apply for"}>
                        <select style={{ padding: "4px" }} value={currentChild.name} onChange={(e) => {
                            if (e.target.value === "You") {
                                this.onApplicationTypeChanged("You");
                                return;
                            }
                            const _list = FakeData.listify(profile.children).filter((item, i) => {
                                return item.user.name === e.target.value;
                            });

                            if (_list.length > 0) {
                                app.type = "Child";
                                this.setState({ currentChild: _list[0].user, app });
                                this.getProfile(_list[0].user);
                            } else if (_list.length === 0 && e.target.value === "") {
                                this.setState({ errorChild: true });
                            }
                        }} ref={(node) => {
                            if (node) {
                                node.style.setProperty("border", "1px solid #ccc", "important");
                                node.style.setProperty("height", "30px", "important");
                            }
                        }}>
                            <option value={""}>Select child</option>
                            <option value={"You"}>You</option>
                            {
                                profile.children.map((item, i) => {
                                    return (
                                        <option key={i} value={item.user.name}>{item.user.name}</option>
                                    )
                                })
                            }
                        </select>
                    </InputField>
                }
                <div className={"split-input"}>
                    <InputField label={"Player First Name"}>
                        <input disabled={isPreview} style={{ padding: "4px" }} value={app.profile.first_name} readOnly />
                    </InputField>
                    <InputField label={"Player Last Name"}>
                        <input disabled={isPreview} style={{ padding: "4px" }} value={app.profile.last_name} readOnly />
                    </InputField>
                </div>
                <div className={"split-input"}>
                    <InputField label={"Player Mobile Number"}>
                        <input disabled={isPreview} style={{ padding: "4px" }} value={app.profile.phone} readOnly />
                    </InputField>
                    <InputField label={"Player Email"}>
                        <input disabled={isPreview} style={{ padding: "4px" }} value={app.profile.email} readOnly />
                    </InputField>
                </div>
                <div className={"split-input"}>
                    <InputField label={"Address"}>
                        <input disabled={isPreview} style={{ padding: "4px" }} value={app.profile.address} readOnly />
                    </InputField>
                    <InputField label={"Suburb"}>
                        <input disabled={isPreview} style={{ padding: "4px" }} value={app.profile.suburb} readOnly />
                    </InputField>
                </div>
                <InputField label={"State/Province"}>
                    <input disabled={isPreview} style={{ padding: "4px" }} value={app.profile.state} readOnly />
                </InputField>
                <div className={"split-input"}>
                    <InputField label={"Postal Code"}>
                        <input disabled={isPreview} style={{ padding: "4px" }} value={app.profile.postal} readOnly />
                    </InputField>
                    <InputField label={"Country"}>
                        <input disabled={isPreview} style={{ padding: "4px" }} value={app.profile.country} readOnly />
                    </InputField>
                </div>
                <div className={"split-input"}>
                    <InputField label={"Player Height"}>
                        <input disabled={isPreview} style={{ padding: "4px" }} value={app.profile.user_height} readOnly />
                    </InputField>
                    <InputField label={"Player Weight"}>
                        <input disabled={isPreview} style={{ padding: "4px" }} value={app.profile.user_weight} readOnly />
                    </InputField>
                </div>

                {!app.isTeam &&
                    <div className={"split-input"}>
                        <InputField label={"Select Team"}>
                            <select className={errors.team ? "error" : ""} disabled={isPreview} value={app.team.name} style={{ padding: "4px" }} onChange={(e) => {
                                const _list = FakeData.listify(this.props.team.teams.current).filter((item, i) => {
                                    return item.name === e.target.value
                                });

                                app.team = _list[0];
                                errors.team = false;
                                app.squad = _list[0].squadId;
                                errors.squad = false;
                                app.sport = FakeData.nullify(_list[0].sport.name).toLowerCase();
                                errors.sport = false;

                                this.setState({ app, errors });
                            }} ref={(node) => {
                                if (node) {
                                    node.style.setProperty("border", "1px solid #ccc", "important");
                                    node.style.setProperty("height", "30px", "important");
                                }
                            }}>
                                <option value={""}>Select Team</option>
                                {
                                    FakeData.listify(this.props.team.teams.current).map((item, i) => {
                                        return (
                                            <option key={i} value={item.name}>{item.name} - {item.sport.name}</option>
                                        )
                                    })
                                }
                            </select>
                        </InputField>

                        <InputField label={"Position"}>
                            <select className={errors.position ? "error" : ""} style={{ padding: "4px" }} disabled={isPreview ? true : app.sport === "" ? true : false} value={app.position} onChange={(e) => {
                                app.position = e.target.value;
                                errors.position = false;
                                this.setState({ app, errors });
                            }} ref={(node) => {
                                if (node) {
                                    node.style.setProperty("border", "1px solid #ccc", "important");
                                    node.style.setProperty("height", "30px", "important");
                                }
                            }}>
                                <option value={""}>Select Position</option>
                                {
                                    FakeData.listify(Positions[app.sport.toLowerCase()]).map((item, i) => {
                                        return (
                                            <option key={i} value={item}>{item}</option>
                                        )
                                    })
                                }
                            </select>
                        </InputField>
                    </div>
                }
                {app.isTeam &&
                    <div className={"split-input"}>
                        <InputField label={"Select Squad"}>
                            <select className={errors.squad ? "error" : ""} disabled={isPreview} value={app.activeSquad.name} style={{ padding: "4px" }} onChange={(e) => {
                                const _list = FakeData.listify(this.props.team.squads.current).filter((item, i) => {
                                    return item.name === e.target.value
                                });

                                app.activeSquad = _list[0];
                                app.squad = _list[0].id;
                                errors.squad = false;
                                this.setState({ app, errors });
                            }} ref={(node) => {
                                if (node) {
                                    node.style.setProperty("border", "1px solid #ccc", "important");
                                    node.style.setProperty("height", "30px", "important");
                                }
                            }}>
                                <option value={""}>Select Squad</option>
                                {
                                    FakeData.listify(this.props.team.squads.current).filter((_team, _i) => {
                                        if (_team.age === "Mixed") {
                                            return true;
                                        } else if (app.profile.age > 20) {
                                            return _team.age === "Seniors";
                                        } else {
                                            var _age = parseInt(app.profile.age);
                                            return _team.age <= _age;
                                        }
                                    }).map((item, i) => {
                                        return (
                                            <option key={i} value={item.name}>{item.name}</option>
                                        )
                                    })
                                }
                            </select>
                        </InputField>
                        <InputField label={"Position"}>
                            <select className={errors.position ? "error" : ""} style={{ padding: "4px" }} disabled={isPreview ? true : app.sport === "" ? true : false} value={app.position} onChange={(e) => {
                                app.position = e.target.value;
                                errors.position = false;
                                this.setState({ app, errors });
                            }} ref={(node) => {
                                if (node) {
                                    node.style.setProperty("border", "1px solid #ccc", "important");
                                    node.style.setProperty("height", "30px", "important");
                                }
                            }}>
                                <option value={""}>Select Position</option>
                                {
                                    FakeData.listify(Positions[app.sport.toLowerCase()]).map((item, i) => {
                                        return (
                                            <option key={i} value={item}>{item}</option>
                                        )
                                    })
                                }
                            </select>
                        </InputField>
                    </div>
                }

                {isPreview && !isDeclining &&
                    <InputField label={"Jersey Number"}>
                        <input type={"number"} disabled={app.isRead} className={errors.jersey ? "error" : ""} style={{ padding: "4px" }} value={app.jersey} onChange={(e) => {
                            app.jersey = e.target.value;
                            errors.jersey = false;
                            this.setState({ app, errors });
                        }} />
                    </InputField>
                }

                {FakeData.listify(app.profile.parents).length > 0 && <h3>Parents</h3>}
                {FakeData.listify(app.profile.parents).length > 0 && <br />}
                {FakeData.listify(app.profile.parents).length > 0 &&
                    <div className={"application-parent-list"}>
                        {
                            FakeData.listify(app.profile.parents).map((item, i) => {
                                return (
                                    <div key={i} className={"application-parent-list-item"}>
                                        <div className={"application-parent-list-item-head"}>
                                            <img src={item.user.image} />
                                            <span>{item.user.name}</span>
                                        </div>
                                        <div className={"application-parent-list-item-body"}>
                                            {item.user.email &&
                                                <span className={"application-parent-list-item-body-item"}>
                                                    <strong>Email</strong>
                                                    <span>{item.user.email}</span>
                                                </span>
                                            }
                                            {item.user.mobile &&
                                                <span className={"application-parent-list-item-body-item"}>
                                                    <strong>Mobile</strong>
                                                    <span>{item.user.mobile}</span>
                                                </span>
                                            }
                                            {item.user.phone &&
                                                <span className={"application-parent-list-item-body-item"}>
                                                    <strong>Phone</strong>
                                                    <span>{item.user.phone}</span>
                                                </span>
                                            }
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                }

                {!isDeclining &&
                    <InputField label={"Comment"} style={{ height: "auto" }}>
                        <textarea className={errors.comment ? "error" : ""} disabled={isPreview} value={app.comment} onChange={(e) => {
                            app.comment = e.target.value;
                            errors.comment = false;
                            this.setState({ app, errors });
                        }} style={{ resize: "vertical", minHeight: "100px" }} />
                    </InputField>
                }
                {!isPreview && !isDeclining && <button className={"button"} onClick={this.save.bind(this)}>Apply</button>}
                {isPreview && !app.isRead && !isDeclining && <button className={"button"} onClick={this.accept.bind(this)}>Accept</button>}
                {isPreview && !app.isRead && !isDeclining && <button className={"button"} style={{ background: "#f43" }} onClick={() => {
                    this.setState({ isDeclining: true });
                }}>Decline</button>}
                {isPreview && isDeclining &&
                    <InputField label={"Please comment on this action"} style={{ height: "auto" }}>
                        <textarea className={errors.declineComment ? "error" : ""} value={app.declineComment} onChange={(e) => {
                            app.declineComment = e.target.value;
                            errors.declineComment = false;
                            this.setState({ app, errors });
                        }} style={{ resize: "vertical", minHeight: "100px" }} />
                    </InputField>
                }
                {isPreview && isDeclining && <button className={"button"} onClick={() => {
                    this.setState({ isDeclining: false });
                }}>Cancel</button>}
                {isPreview && isDeclining && <button className={"button"} onClick={this.decline.bind(this)}>Decline</button>}

                {isAddingChild &&
                    <Register onRegister={this.onRegister.bind(this)} {...this.props} isEmbed={true} isParent={true} user={profile} isOpen={isAddingChild} onClose={(child) => {
                        if (child) {
                            this.getProfile(child, "username");
                            this.setState({ isAddingChild: false });
                        } else {
                            this.setState({ isAddingChild: false });
                        }
                    }} />
                }
            </div>
        );
    }
}

ApplicationForm.propTypes = {

};

export class LoginButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        }
    }

    render = () => {
        const { isOpen } = this.state;

        return (
            <div>
                <button className={"button"} onClick={() => {
                    this.setState({ isOpen: true });
                }}>Login</button>
                {isOpen &&
                    <Login isOpen={isOpen} onLogin={(bool = false) => {
                        this.setState({ isOpen: false });
                        if (bool) {
                            window.location.reload();
                        }
                    }} onClose={(bool = false) => {
                        this.setState({ isOpen: false });
                        if (bool) {
                            window.location.reload();
                        }
                    }} isEmbed={true} />
                }
            </div>
        )
    }

}

export default ApplicationForm;


// WEBPACK FOOTER //
// ./src/components/ApplicationForm.js